export const siteInfo = {
  brand: "溯影档案",
  slogan: "不追热乎的，专挖陈年旧料",
  intro:
    "溯影档案是一个以考据方式整理网络人物公开言行的观察站。我们把早期发言、旧照旧言论与前科记录按时间线拼回原位，标注出处与核对路径，让每一次围观都建立在可复核的事实之上。",
  positioning: "网络人物言行回溯观察站",
  email: "archive@suying-dangan.example",
  replyTime: "一般 2 个工作日内回复",
  founded: "2019 年",
  location: "线上协作 · 上海 / 成都",
  stats: [
    { label: "已立档人物", value: "1,286", unit: "位" },
    { label: "存证条目", value: "47,900", unit: "条" },
    { label: "考据专题", value: "312", unit: "篇" },
    { label: "核对修正", value: "1,540", unit: "次" },
  ],
};

export const categories = [
  {
    slug: "early-words",
    name: "早期言论",
    desc: "从模糊的直播录屏与论坛旧帖里，捞回那些后来被悄悄删掉的原话。",
    icon: "ri-chat-history-line",
    count: 96,
  },
  {
    slug: "old-photos",
    name: "旧照对比",
    desc: "同一个人、不同年份的公开影像并置，看修图与叙事一起变了多少。",
    icon: "ri-image-2-line",
    count: 74,
  },
  {
    slug: "record",
    name: "前科记录",
    desc: "只引用可核对的公开处理结果与平台公告，不做无据推测。",
    icon: "ri-file-shield-2-line",
    count: 41,
  },
  {
    slug: "persona",
    name: "人设落差",
    desc: "把对外口号与真实行为放在一张时间轴上，落差自己会说话。",
    icon: "ri-user-voice-line",
    count: 63,
  },
  {
    slug: "receipt",
    name: "凭证核对",
    desc: "捐款、学历、资质的图片逐张留档，核对时间与来源链。",
    icon: "ri-receipt-line",
    count: 28,
  },
  {
    slug: "plagiarism",
    name: "搬运考据",
    desc: "文案与画面的最早出处比对，还原一次内容搬运的完整路径。",
    icon: "ri-file-copy-2-line",
    count: 30,
  },
];

export const methodSteps = [
  {
    step: "01",
    title: "锁定公开线索",
    desc: "只从公开发布的内容出发，记录可访问的链接、截图与时间戳，私人信息一律不碰。",
    icon: "ri-search-eye-line",
  },
  {
    step: "02",
    title: "建立时间轴",
    desc: "把每条发言、每张旧照按发布时间排好队，先看顺序，再谈结论。",
    icon: "ri-timeline-view",
  },
  {
    step: "03",
    title: "交叉核对",
    desc: "同一件事至少找两个独立来源互相印证，孤证只做存疑标记，不当定论。",
    icon: "ri-node-tree",
  },
  {
    step: "04",
    title: "标注与修正",
    desc: "每条档案都写明出处与存疑点，收到当事人合理说明后公开修订，不偷偷改动。",
    icon: "ri-edit-2-line",
  },
];

export const archives = [
  {
    slug: "kou-tou-chan-zao-qi-zhibo",
    title: "十年前的那句口头禅：从直播录屏看她到底改没改口",
    category: "早期言论",
    categorySlug: "early-words",
    date: "2026-08-14",
    readMinutes: 9,
    views: "128,430",
    heat: "高热",
    tags: ["直播录屏", "口头禅", "人设转变"],
    summary:
      "一段 2016 年的低清录屏里，某头部美食主播反复用一句带地域指向的口头禅活跃气氛。多年后她公开主张尊重多元，两段素材被并排放到时间轴上。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cream%20desk%20with%20a%20single%20blurred%20old%20video%20still%20printout%20and%20a%20magnifying%20glass%2C%20rust%20red%20wool%20thread%20connecting%20two%20dated%20photo%20corners%2C%20archival%20investigation%20still%20life%2C%20soft%20daylight%2C%20muted%20earthy%20tones%2C%20calm%20editorial%20photography&width=1200&height=750&seq=suying-arch-early-words-01&orientation=landscape",
    lead:
      "这段话最早出现在 2016 年 4 月的一场深夜直播里，画面只有 360p，但音频清楚。档案组把这句口头禅出现的 11 个时间点全部标注出来，再看它在 2021 年之后的发言里如何消失。",
    timeline: [
      { year: "2016", text: "深夜直播中首次出现该口头禅，用于调侃连麦嘉宾的口音" },
      { year: "2018", text: "粉丝剪辑合集将这句话做成固定梗，播放量破百万" },
      { year: "2021", text: "公开访谈中首次表示'以前说话没分寸'，未点名具体内容" },
      { year: "2024", text: "该合集原作者删除视频，账号未说明原因" },
      { year: "2026", text: "旧录屏被重新上传，引发新一轮讨论" },
    ],
    sections: [
      {
        heading: "为什么一句口头禅值得单独立档",
        paragraphs: [
          "口头禅本身不是罪证，但它是一个人早期语境最直白的切片。当公众人物的公开立场发生转向时，最先被察觉的往往就是这类无意识的语气词。",
          "档案组在意的是：这句话在不同年份的出现频率是否真的下降，还是只是换了发布平台。频率曲线比任何一段截图都更能说明问题。",
        ],
      },
      {
        heading: "把'没分寸'当成理解而非定性",
        paragraphs: [
          "很多早期表达带有强烈的时代烙印：当时的直播生态鼓励夸张、鼓励地域梗，观众的容忍度也不同。把这些语境去掉只看截屏，容易得出过重的结论。",
          "因此本篇档案在每条时间点旁都附上'当时的平台氛围'注记，读者可以自行判断哪些属于时代局限，哪些属于个人的持续选择。",
        ],
      },
    ],
    evidence: [
      { label: "2016 深夜直播录屏（原始文件）", note: "音频完整，画面 360p，已存档校验哈希" },
      { label: "2018 粉丝剪辑合集", note: "原视频已删除，仅存公开转载版本，标注存疑" },
      { label: "2021 公开访谈逐字稿", note: "来自官方账号发布，可核对" },
    ],
    related: ["xiao-hao-hua-shu-cha-yi", "ren-she-luo-cha-de-qi-dian"],
  },
  {
    slug: "jiu-zhao-dui-bi-san-ge-nian-fen",
    title: "三张公开旧照并置：同一个人、同一件外套、三个年份",
    category: "旧照对比",
    categorySlug: "old-photos",
    date: "2026-07-30",
    readMinutes: 7,
    views: "96,210",
    heat: "中热",
    tags: ["旧照", "修图", "公开影像"],
    summary:
      "某生活类创作者每年生日都会发布同款角度照片。把 2019、2022、2025 三张原图放进同一网格，轮廓的变化比任何文字声明都更值得记录。",
    cover:
      "https://readdy.ai/api/search-image?query=Three%20overlapping%20aged%20photographic%20prints%20on%20cream%20linnen%20surface%2C%20faded%20portrait%20silhouettes%20without%20faces%2C%20brass%20photo%20corners%20and%20a%20worn%20ruler%2C%20archival%20comparison%20still%20life%2C%20soft%20window%20light%2C%20muted%20sepia%20and%20rust%20palette&width=1200&height=750&seq=suying-arch-old-photos-01&orientation=landscape",
    lead:
      "这不是'整容鉴定'，而是一次关于公开影像可信度的整理。当一个人年复一年使用同一机位、同一姿势，变化本身就成了一份可对比的公开记录。",
    timeline: [
      { year: "2019", text: "生日贴发布首张同款角度照片，背景为出租屋白墙" },
      { year: "2022", text: "同一机位照片出现，背景换成摄影棚灰幕" },
      { year: "2025", text: "第三张同款照片发布，评论区开始出现对比讨论" },
      { year: "2026", text: "本人回应称'角度和光线问题'，未提供更多说明" },
    ],
    sections: [
      {
        heading: "影像对比该做到什么程度算合适",
        paragraphs: [
          "档案组的底线是：只使用当事人主动公开的照片，不使用任何私密影像或未经授权的截图，也不对照片做拉伸、变形等二次加工来夸大差异。",
          "我们更关注'影像是如何被讲述的'——同一张图配不同文案，传达的意思天差地别。这才是旧照考古真正有价值的部分。",
        ],
      },
      {
        heading: "修图时代，旧照为什么还重要",
        paragraphs: [
          "当精修成为常态，早期未经修饰的影像反而成了稀缺的参照物。它不证明什么，只是提供了另一种可能的样子。",
          "重要的是把讨论拉回到'公开表达与真实经历之间的距离'，而不是对个人外貌指指点点。",
        ],
      },
    ],
    evidence: [
      { label: "2019 生日贴原图", note: "来自当事人公开账号，含发布时间戳" },
      { label: "2022 生日贴原图", note: "同上，机位与构图高度一致" },
      { label: "2025 生日贴原图", note: "评论区讨论截图已单独存档" },
    ],
    related: ["kou-tou-chan-zao-qi-zhibo", "juan-kuan-ping-zheng-de-shi-jian-cha"],
  },
  {
    slug: "he-zuo-shi-pin-bei-shan-chu",
    title: "被下架的联名视频：一次合作翻车留下的存档",
    category: "前科记录",
    categorySlug: "record",
    date: "2026-07-11",
    readMinutes: 8,
    views: "74,980",
    heat: "中热",
    tags: ["平台公告", "合作翻车", "公开处理"],
    summary:
      "某带货博主与品牌的联名系列因宣传口径问题被平台下架。档案组只引用平台公告与品牌方公开声明的原文，不做额外推断。",
    cover:
      "https://readdy.ai/api/search-image?query=Closed%20cardboard%20archive%20box%20sealed%20with%20rust%20red%20paper%20tape%20and%20a%20blank%20official%20notice%20sheet%2C%20standing%20on%20cream%20paper%20surface%2C%20muted%20earth%20tones%2C%20soft%20directional%20light%2C%20documentary%20still%20life%2C%20calm%20editorial%20composition&width=1200&height=750&seq=suying-arch-record-01&orientation=landscape",
    lead:
      "涉及处理结果的内容最容易变形。档案组的做法是：把官方原文照录，单独成栏，与任何网友转述严格分开，方便读者各取所需。",
    timeline: [
      { year: "2025-11", text: "联名系列上线，首场直播销售额公布" },
      { year: "2025-12", text: "多位消费者反馈宣传与实际不符，品牌方发布初步说明" },
      { year: "2026-01", text: "平台发布处理公告，相关视频与商品链接下架" },
      { year: "2026-03", text: "博主账号恢复更新，未就该事件再作说明" },
    ],
    sections: [
      {
        heading: "引用公告的三个纪律",
        paragraphs: [
          "第一，全文照录，不改一个字，注释另起一栏；第二，注明公告的原始出处与发布日期；第三，若公告后续更新，新旧两版同时保留，不做覆盖。",
          "这三条看起来啰嗦，但正是它让档案在几年后依然站得住。",
        ],
      },
      {
        heading: "处理结果不等于全部的真相",
        paragraphs: [
          "平台公告只描述平台关注的维度，未必涵盖事件的每个侧面。把它当成'结论'会漏掉很多细节，当成'材料'才更接近事实。",
          "因此本篇在公告原文之外，还并列了品牌方声明与三方消费者的公开反馈，供读者对照。",
        ],
      },
    ],
    evidence: [
      { label: "平台处理公告原文", note: "官方账号发布，含公告编号" },
      { label: "品牌方初步说明", note: "品牌官微发布，保留原始链接" },
      { label: "消费者公开反馈汇总", note: "仅收录公开发布内容，已脱敏" },
    ],
    related: ["yi-zi-bu-chai-de-yuan-tou", "ren-she-luo-cha-de-qi-dian"],
  },
  {
    slug: "xiao-hao-hua-shu-cha-yi",
    title: "小号里的另一套话术：同一人两个账号的语气差",
    category: "人设落差",
    categorySlug: "persona",
    date: "2026-06-22",
    readMinutes: 6,
    views: "88,120",
    heat: "高热",
    tags: ["小号", "话术", "语气分析"],
    summary:
      "主账号温和克制，早期小号却锋利直白。两个账号的用词习惯被做了词频统计，结论交给读者自己下。",
    cover:
      "https://readdy.ai/api/search-image?query=Two%20open%20handwritten%20notebooks%20side%20by%20side%20on%20cream%20desk%2C%20one%20with%20soft%20rounded%20script%20the%20other%20with%20sharp%20angular%20strokes%2C%20ink%20pen%20and%20rust%20red%20ribbon%2C%20editorial%20comparison%20still%20life%2C%20warm%20soft%20light%2C%20muted%20palette&width=1200&height=750&seq=suying-arch-persona-01&orientation=landscape",
    lead:
      "'小号考古'是这两年最常见的围观方式，也是最容易踩线的一类。档案组只统计当事人自己公开承认过的账号，不扩展猜测。",
    timeline: [
      { year: "2017", text: "小号开始活跃，发帖频率高，语气直白" },
      { year: "2020", text: "主账号起量，小号更新骤减" },
      { year: "2023", text: "当事人访谈中承认小号存在，称'年轻气盛'" },
      { year: "2025", text: "小号设为私密，历史内容不可见" },
    ],
    sections: [
      {
        heading: "语气差异能说明什么，不能说明什么",
        paragraphs: [
          "词频与句长的差异可以量化，但它只在'当事人已承认双账号'的前提下才有讨论价值。仅凭头像风格或者 id 相似就串联账号，越界且不负责任。",
          "本篇的所有统计都基于当事人公开承认的时间段，其余一律标注为'未经确认'。",
        ],
      },
      {
        heading: "为什么我们要给'年轻气盛'留位置",
        paragraphs: [
          "七年前的互联网表达生态和今天差别很大，很多当时被当成'有个性'的语气，放到今天会被重新解读。承认时间的作用，不等于否认责任。",
          "档案组更愿意呈现的是变化的轨迹，而不是某一句最刺眼的截屏。",
        ],
      },
    ],
    evidence: [
      { label: "2017-2020 小号公开帖", note: "当事人已承认归属，按时间段归档" },
      { label: "2023 访谈承认片段", note: "官方视频发布，可核对" },
      { label: "词频统计表", note: "档案组自建口径，附统计方法说明" },
    ],
    related: ["kou-tou-chan-zao-qi-zhibo", "yi-zi-bu-chai-de-yuan-tou"],
  },
  {
    slug: "juan-kuan-ping-zheng-de-shi-jian-cha",
    title: "捐款截图背后的时间差：凭证核对的完整流程",
    category: "凭证核对",
    categorySlug: "receipt",
    date: "2026-05-28",
    readMinutes: 10,
    views: "61,340",
    heat: "中热",
    tags: ["捐款", "凭证", "时间戳"],
    summary:
      "某博主在热点期间发布捐款截图，但截图与到账记录的时间相差数天。档案组只核对公开可查的时间戳，不评价动机。",
    cover:
      "https://readdy.ai/api/search-image?query=Vintage%20wooden%20desk%20with%20a%20stack%20of%20faded%20receipt%20slips%2C%20brass%20magnifier%20and%20a%20small%20ink%20stamp%2C%20rust%20red%20string%20tie%2C%20warm%20cream%20paper%20texture%2C%20muted%20earth%20tones%2C%20soft%20documentary%20light&width=1200&height=750&seq=suying-arch-receipt-01&orientation=landscape",
    lead:
      "凭证类档案的关键在于'时间戳'。同一笔款，捐款日、截图日、公示日三个时间点各不相同，把它们并排摆出来，讨论自然就会具体。",
    timeline: [
      { year: "2024-08-02", text: "热点事件发生当天，博主发布捐款截图" },
      { year: "2024-08-05", text: "网友比对发现正式到账记录日期为 8 月 4 日" },
      { year: "2024-08-06", text: "博主补充说明为'转账有延迟'" },
      { year: "2024-09", text: "相关平台公布公益账单，该笔捐款在列" },
    ],
    sections: [
      {
        heading: "时间差本身不是指控",
        paragraphs: [
          "银行转账、公益平台到账、公示更新之间本来就存在处理周期。把三个时间点分开标注，是为了让读者知道差别在哪里，而不是证明谁在撒谎。",
          "档案组刻意避免使用'造假'这类定性词，只描述时间关系。",
        ],
      },
      {
        heading: "一张合格的凭证存证长什么样",
        paragraphs: [
          "合格的存证至少包含：原始图片文件、发布页面链接、页面快照与抓取时间、以及可公开核对的第三方记录。缺一环，结论强度就下降一级。",
          "本篇档案把这四项整理成一张表格，读者可逐项对照。",
        ],
      },
    ],
    evidence: [
      { label: "发布当天截图", note: "含页面快照与抓取时间" },
      { label: "公益平台公示账单", note: "第三方可公开查询" },
      { label: "博主补充说明", note: "来自其公开账号，原链接保留" },
    ],
    related: ["jiu-zhao-dui-bi-san-ge-nian-fen", "he-zuo-shi-pin-bei-shan-chu"],
  },
  {
    slug: "yi-zi-bu-chai-de-yuan-tou",
    title: "抄来的文案：一条搬运路径是怎么被还原的",
    category: "搬运考据",
    categorySlug: "plagiarism",
    date: "2026-05-09",
    readMinutes: 7,
    views: "52,760",
    heat: "低热",
    tags: ["搬运", "原创", "出处比对"],
    summary:
      "某知识区创作者的一条爆款视频，文案与三年前一篇公开文章高度重合。档案组按句子比对，标注重合段落与改写方式。",
    cover:
      "https://readdy.ai/api/search-image?query=Two%20aged%20manuscript%20pages%20overlapping%20on%20cream%20linen%2C%20identical%20paragraph%20blocks%20marked%20with%20rust%20red%20pencil%20lines%2C%20brass%20paper%20clip%2C%20warm%20soft%20window%20light%2C%20muted%20sepia%20archival%20still%20life&width=1200&height=750&seq=suying-arch-plagiarism-01&orientation=landscape",
    lead:
      "搬运考据最怕情绪先行。档案组的方法是先做句子级比对，用颜色区分'原样照搬''同义改写''结构相似'三类重合，再谈这属于什么程度的问题。",
    timeline: [
      { year: "2022-11", text: "某公开文章发布，主题与结构完整" },
      { year: "2025-03", text: "创作者发布爆款视频，文案结构与上文高度接近" },
      { year: "2025-04", text: "原文章作者公开发声，要求标注来源" },
      { year: "2025-05", text: "创作者在视频简介补加来源说明" },
    ],
    sections: [
      {
        heading: "三类重合的区分标准",
        paragraphs: [
          "'原样照搬'指连续 15 字以上一致；'同义改写'指句式结构相同但用词替换；'结构相似'指论点顺序与例子一致但表达独立。三者的性质差别很大。",
          "本篇档案按这三档逐段标注，让读者看到重合集中在哪些部分。",
        ],
      },
      {
        heading: "补标来源之后还需要什么",
        paragraphs: [
          "补标来源是修复的第一步，但公开内容的引用规范不止于此：原文作者的授权范围、二次使用的边界，都值得单独讨论。",
          "档案组的立场是记录事实与后续处理，而非替任何一方下最终判断。",
        ],
      },
    ],
    evidence: [
      { label: "2022 公开文章原文", note: "含首次发布时间" },
      { label: "2025 视频文案逐字稿", note: "由公开视频转录" },
      { label: "句子级比对表", note: "含三档重合标注与判定依据" },
    ],
    related: ["xiao-hao-hua-shu-cha-yi", "he-zuo-shi-pin-bei-shan-chu"],
  },
  {
    slug: "ren-she-luo-cha-de-qi-dian",
    title: "人设落差的起点：同一句承诺，两年后换了说法",
    category: "人设落差",
    categorySlug: "persona",
    date: "2026-04-18",
    readMinutes: 6,
    views: "69,880",
    heat: "中热",
    tags: ["承诺", "公开表达", "前后对比"],
    summary:
      "某创作者早期承诺'永远不带货'，两年后开始常规带货。档案组把两段公开表达并列，不做道德审判，只呈现变化的节点。",
    cover:
      "https://readdy.ai/api/search-image?query=Single%20torn%20paper%20scroll%20on%20cream%20desk%20showing%20two%20different%20handwritten%20statements%2C%20wax%20seal%20and%20rust%20red%20thread%2C%20warm%20side%20light%2C%20muted%20earth%20tones%2C%20quiet%20archival%20editorial%20still%20life&width=1200&height=750&seq=suying-arch-persona-02&orientation=landscape",
    lead:
      "人设不是合同，公开承诺也未必有法律效力。但当一个账号的定位发生转向，把前后两次表达摆在一起，对理解这个账号很有帮助。",
    timeline: [
      { year: "2022", text: "早期视频中明确表示不接受商业合作" },
      { year: "2023", text: "开始出现品牌植入，解释为'团队需要养活'" },
      { year: "2025", text: "开设带货专场，商业内容占比明显上升" },
      { year: "2026", text: "粉丝在评论区提及旧承诺，账号未正面回应" },
    ],
    sections: [
      {
        heading: "创作者的商业化不是原罪",
        paragraphs: [
          "内容创作需要收入支撑，转向商业化本身无可厚非。档案组关注的从来不是'该不该带货'，而是'公共表达与后续行为之间是否给了说明'。",
          "把这两点分开看，讨论才不会被情绪裹挟。",
        ],
      },
      {
        heading: "存档的意义在于让变化可见",
        paragraphs: [
          "如果没有留下早期的表达，社区的记忆会被算法推荐不断稀释，最后只剩下最近一次的印象。存档让时间维度重新回到讨论里。",
          "这也是溯影档案做这件事的全部理由。",
        ],
      },
    ],
    evidence: [
      { label: "2022 早期视频原片", note: "公开视频，含发布日期" },
      { label: "2023 植入内容记录", note: "按发布时间列示" },
      { label: "2025 带货专场海报", note: "官方账号发布" },
    ],
    related: ["kou-tou-chan-zao-qi-zhibo", "he-zuo-shi-pin-bei-shan-chu"],
  },
  {
    slug: "ping-tai-gong-gao-de-yue-du-fang-fa",
    title: "读平台公告的正确姿势：别只截最狠的那一句",
    category: "前科记录",
    categorySlug: "record",
    date: "2026-03-27",
    readMinutes: 8,
    views: "43,510",
    heat: "低热",
    tags: ["平台公告", "阅读方法", "存档规范"],
    summary:
      "平台公告往往同时包含结论与背景。只截结论那一句，很容易把'违规'放大成'犯罪'。本篇整理一套公告阅读与存档的通用方法。",
    cover:
      "https://readdy.ai/api/search-image?query=Single%20blank%20official%20notice%20sheet%20pinned%20to%20a%20cream%20cork%20board%20with%20brass%20pins%2C%20rust%20red%20underlined%20line%2C%20warm%20soft%20light%2C%20muted%20earth%20palette%2C%20calm%20documentary%20still%20life&width=1200&height=750&seq=suying-arch-record-02&orientation=landscape",
    lead:
      "公告是少数由机构盖过章的材料，含金量高，但也最容易被断章取义。建立一套固定的阅读流程，比记住任何一个具体结论都重要。",
    timeline: [
      { year: "2023", text: "开始整理公告类材料，建立统一存档模板" },
      { year: "2024", text: "模板增加'上下文摘要'与'后续更新'两栏" },
      { year: "2025", text: "向公众开放部分模板说明" },
      { year: "2026", text: "整理为可复用的公告阅读指南" },
    ],
    sections: [
      {
        heading: "先读四要素，再看处理结果",
        paragraphs: [
          "任何公告都先确认四件事：发布主体、发布日期、适用条款、有效期限。这四项定了，再读处理结果，才不会被单句带偏。",
          "很多争议其实源于把'阶段性处理'当成了'最终定性'。",
        ],
      },
      {
        heading: "存档时保留完整版本",
        paragraphs: [
          "公告可能被修改或下架。存档时要保留完整页面快照、抓取时间与来源链接，并在公告更新后保留新旧两版。",
          "只存一张裁剪过的截图，等于把最容易被质疑的部分留给了别人。",
        ],
      },
    ],
    evidence: [
      { label: "公告存档模板 v3", note: "含四要素与上下文栏位" },
      { label: "历史公告案例集", note: "已脱敏，仅作方法示例" },
    ],
    related: ["he-zuo-shi-pin-bei-shan-chu", "yi-zi-bu-chai-de-yuan-tou"],
  },
];

export const testimonials = [
  {
    name: "老周",
    role: "追更三年",
    text: "别的地方都是上来就下结论，这里会把时间轴铺开让你自己看。看完再去评论区，心态平和多了。",
  },
  {
    name: "阿穗",
    role: "内容创作者",
    text: "最服的是修正机制。有一次档案里有条信息不对，他们当天就发了修订说明，把原版也留着了。",
  },
  {
    name: "林一",
    role: "媒介素养教师",
    text: "我把这里的核对方法直接拿去做课堂例子，学生第一次明白'截图不等于事实'具体是什么意思。",
  },
];

export const faqs = [
  {
    q: "溯影档案整理的黑料网红旧言论，来源是否可靠？",
    a: "所有内容只取自公开发布的材料，包括当事人自己的账号、平台公告与可访问的公开文章。每条档案都附出处标注，对无法核实的部分会明确标为'存疑'，而不是当作事实陈列。",
  },
  {
    q: "这里会不会涉及他人的隐私信息？",
    a: "不会。档案组不收集、不发布任何非公开的个人信息，包括私人联系方式、住址、非公开的家庭关系等。我们只处理当事人主动公开过的内容，并保持这一边界。",
  },
  {
    q: "如果我是当事人，认为档案里的内容有误怎么办？",
    a: "可以通过联系页提交说明，并附上可核对的材料。核对属实后我们会公开修订，并保留修订前后两个版本，让改动过程可追溯。",
  },
  {
    q: "为什么有的档案标题看起来很'狠'，内容却很克制？",
    a: "标题指向的是被讨论的公开事实，正文则严格区分'已核实''待核实''存疑'三档。我们希望读者点进来之后，获得的是判断依据而不是情绪。",
  },
  {
    q: "黑历史考古这件事到底有没有意义？",
    a: "有意义的部分在于留存公共表达的变化轨迹，帮助人们理解网络言论的时效性。没有意义甚至有害的部分，是把它当成攻击工具。档案组坚持前一种。",
  },
  {
    q: "档案会长期保留吗，会不会被删掉？",
    a: "已发布的档案会长期保留，并定期校验存档文件。如果原始链接失效，我们会标注失效时间，但仍保留已存档的快照与校验信息。",
  },
];

export const siteTimeline = [
  { year: "2019", text: "从一个私人整理的旧帖收藏夹起步" },
  { year: "2021", text: "建立统一的时间轴与出处标注规范" },
  { year: "2023", text: "开放公众线索提交通道" },
  { year: "2025", text: "上线修订公示机制，所有改动可追溯" },
  { year: "2026", text: "累计整理公开档案 312 篇" },
];